import React from 'react'

import { useStaticQuery, graphql } from 'gatsby'

import Carousel from 'react-bootstrap/Carousel'
import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'


const Testimonials = () => {

    const data = useStaticQuery(graphql`
         query {
            allContentfulTestimonials {
              edges {
                node {
                    id
                    title
                  testimonial1
                  testimonial1Name
                  testimonialCallToActionButtonText
                }
              }
             
            }
        }
        `)

    const { title } = data.allContentfulTestimonials.edges[0].node

    
    return (
    <section id="testimonials" className="py-5">
        
        <Container>
            <Row className="justify-content-center">
                <h1
                className="d-none d-md-block display-4 font-weight-bolder text-center text-success text-uppercase pt-5"
                >
                    {title}
                </h1>
            </Row>

            <Carousel>
                { data && data.allContentfulTestimonials.edges.map((edge) => ( 

                            <Carousel.Item className="testimonials-item" interval={9000} key={edge.node.id} >

                                <Carousel.Caption className="top-apostrophe">
                                    "
                                </Carousel.Caption>
                            
                                <Carousel.Caption className="text-dark text-center">
                                    <Col className="py-5 align-items-center">          
                                        <h3 className="d-none d-sm-block my-5">
                                            {edge.node.testimonial1}
                                        </h3>
                                                    
                                        <h5
                                            className="d-xs-block d-sm-none d-md-none d-lg-none d-xl-none display-5"
                                        >
                                            {edge.node.testimonial1}
                                        </h5>

                                        <h4 className="d-none d-sm-block">
                                            {edge.node.testimonial1Name}
                                        </h4>
                                        
                                        <p className="d-xs-block d-sm-none d-md-none d-lg-none d-xl-none m-0">
                                            {edge.node.testimonial1Name}
                                        </p>
                                    </Col>
                            
                                    <Button className="d-none d-sm-inline-block inner-link btn btn-warning btn-lg btn-shadow font-weight-bolder">
                                        <h4 className="my-0 text-uppercase font-weight-bolder">{edge.node.testimonialCallToActionButtonText}</h4>
                                    </Button>
                                                
                                </Carousel.Caption>

                                <Carousel.Caption className="bottom-apostrophe">
                                    "
                                </Carousel.Caption>
                            </Carousel.Item>
                        )
                    )
                }
            </ Carousel>

       </Container> 
    </section>
    )
}

export default Testimonials
